export const BOOTSTRAP_STUCK_THRESHOLD_MS = 30000;
